function reader(element, file) {
	var reader  = new FileReader();
  
	reader.onloadend = function () {
		if(element instanceof HTMLImageElement) element.src = reader.result;
		else if(element instanceof HTMLElement) element.style.backgroundImage = `url(${reader.result})`;
	}
  
	if(file) {
		reader.readAsDataURL(file);
	} else {
		if(element instanceof HTMLImageElement) element.src = '';
		else if(element instanceof HTMLElement) element.style.backgroundImage = '';
	}
}